import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'bootstrap/dist/css/bootstrap.min.css';

const Case = () => {
  const [activeTab, setActiveTab] = useState('Smart Devices');

  const tabs = [
    'Smart Devices',
    'Industrial IoT',
    'Home Automation',
    'Wearables',
    'IoT Security',
  ];

  const caseStudies = [
    { img: 'assets/img/case/case_1_1.jpg', title: 'Smart Thermostat', subtitle: 'Home Automation' },
    { img: 'assets/img/case/case_1_2.jpg', title: 'Industrial Sensor Grid', subtitle: 'Industrial IoT' },
    { img: 'assets/img/case/case_1_3.jpg', title: 'Fitness Tracker', subtitle: 'Wearables' },
    { img: 'assets/img/case/case_1_4.jpg', title: 'Smart Lighting System', subtitle: 'Home Automation' },
    { img: 'assets/img/case/case_1_5.jpg', title: 'Smart Irrigation', subtitle: 'Smart Devices' },
    { img: 'assets/img/case/case_1_1.jpg', title: 'IoT Security Gateway', subtitle: 'IoT Security' },
    { img: 'assets/img/case/case_1_2.jpg', title: 'Smart Door Lock', subtitle: 'Home Automation' },
    { img: 'assets/img/case/case_1_3.jpg', title: 'Industrial Monitoring', subtitle: 'Industrial IoT' },
    { img: 'assets/img/case/case_1_4.jpg', title: 'Wearable ECG Monitor', subtitle: 'Wearables' },
    { img: 'assets/img/case/case_1_5.jpg', title: 'Connected Vehicle Tracker', subtitle: 'Smart Devices' },
  ];

  const filteredStudies = caseStudies.filter(
    (item) => item.subtitle === activeTab || activeTab === 'Smart Devices'
  );

  return (
    <div className="case-area position-relative overflow-hidden space py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5 mb-4 mb-xl-0">
            <div className="title-area case-title-box text-center text-xl-start">
              <span className="sub-title mb-15 text-anime-style-2">IoT Projects</span>
              <h2 className="sec-title text-anime-style-3">Empowering Innovation through IoT</h2>
            </div>
          </div>
          <div className="col-xl-7">
            <div className="nav nav-tabs case-tabs" id="nav-tab" role="tablist">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`nav-link th-btn ${activeTab === tab ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="tab-content mt-4" id="nav-tabContent">
          <div className="tab-pane fade active show" role="tabpanel">
            <div className="slider-area case-slider slider-drag-wrap">
              <Swiper
                key={activeTab}
                modules={[Navigation, Pagination, EffectCoverflow, Autoplay]}
                effect="coverflow"
                coverflowEffect={{
                  rotate: 50,
                  stretch: 0,
                  depth: 100,
                  modifier: 1,
                  slideShadows: true,
                }}
                centeredSlides={true}
                navigation
                pagination={{ clickable: true }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  576: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                  1200: { slidesPerView: 3 },
                }}
                className="th-slider case-slider"
              >
                {filteredStudies.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="case-box">
                      <div className="case-img position-relative overflow-hidden rounded">
                        <img
                          src={item.img}
                          alt={item.title}
                          className="img-fluid"
                          style={{ height: '300px', objectFit: 'cover', width: '100%' }}
                        />
                        <div className="case-content position-absolute bottom-0 start-0 w-100 p-3 bg-dark bg-opacity-75 text-white">
                          <div className="media-left">
                            <h4 className="box-title mb-1">{item.title}</h4>
                            <span className="case-subtitle">{item.subtitle}</span>
                          </div>
                        </div>
                        <div className="case-action position-absolute top-0 end-0 m-3">
                          <a
                            href="#"
                            className="case-btn bg-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: '40px', height: '40px' }}
                          >
                            <i className="fas fa-arrow-right text-dark"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Case;
